<template>
	<ContainerCenter>
		<v-card>
			<v-toolbar
				color="primary"
				dark
				flat
			>
				<v-toolbar-title>Esqueci minha senha</v-toolbar-title>
			</v-toolbar>
			<v-card-text v-if="enviado">
				<div class="body-1 text-center">
					Se o e-mail estiver cadastrado, você receberá um link para criar uma nova senha.
					<br> Confira também a caixa de spam.
				</div>
			</v-card-text>
			<v-card-text v-else>
				<v-form
					ref="form"
					@submit.prevent="enviar"
					id="form-esqueci-senha"
				>
					<div class="body-1 text-center mb-2">
						Informe o e-mail cadastrado para receber o link de redefinição de senha
					</div>
					<v-text-field
						autofocus
						name="email"
						label="E-mail"
						type="email"
						autocomplete="email"
						v-model="email"
						:rules="[ obrigatorio, emailValido ]"
					/>
					<div class="caption text--secondary">
						Sem e-mail cadastrado? Procure o secretário da sua loja.
					</div>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn
					v-if="!enviado"
					block
					color="primary"
					type="submit"
					form="form-esqueci-senha"
					:disabled="carregando"
					:loading="carregando"
				> Enviar link </v-btn>
			</v-card-actions>
			<div class="text-center pb-3">
				<router-link :to="{ name: 'login' }">Voltar para o login</router-link>
			</div>
		</v-card>
	</ContainerCenter>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { emailValido, obrigatorio } from '@/shareds/regras'
import { auth } from '@/firebase'
import { alert } from '@/store'
import { normalizarEmail } from '../../../common/shareds/sharedEmail'

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const email = ref('')
const carregando = ref(false)
const enviado = ref(false)

async function enviar() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		auth.languageCode = 'pt_BR'
		await auth.sendPasswordResetEmail(normalizarEmail(email.value), {
			url: `${window.location.origin}/login`,
		})
		enviado.value = true
	} catch (error) {
		// não revela se o e-mail existe
		if ((error as { code?: string }).code === 'auth/user-not-found') {
			enviado.value = true
			return
		}
		alert.setError('Não foi possível enviar o e-mail. Tente novamente mais tarde.')
	} finally {
		carregando.value = false
	}
}
</script>
